import React, { useEffect, useState } from 'react';
import { Button, Input, Card, CardBody, CardHeader, FormGroup, Label, Form, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Table } from 'reactstrap';
import { api } from "../../config";
import { fetchComAuth, fetchComAuthJson } from '../../common/api';

const TelaConfiguracoesTags = ({ feiraId, editando }) => {
  // Estados principais
  const [tags, setTags] = useState([]);
  const [availableTags, setAvailableTags] = useState([]);
  const [filteredAvailableTags, setFilteredAvailableTags] = useState([]); // Tags disponíveis filtradas
  const [modalAberto, setModalAberto] = useState(false);
  const [editandoId, setEditandoId] = useState(null);
  const [tagId, setTagId] = useState('');
  const [cobra_por_metro, setCobrarPorM2] = useState(false);
  const [valor, setValor] = useState(0);

  // Carrega dados iniciais
  useEffect(() => {
    const carregarDados = async () => {
      try {
        // Carrega tags disponíveis
        const responseTags = await fetchComAuth(`${api.API_URL}/tags`, {
          method: 'GET'
        })
        
        const dataTags = await responseTags.json();
        setAvailableTags(dataTags.data);
  
        // Carrega tags configuradas para a feira
        if (feiraId && editando) {
          const responseFeiraTags = await fetchComAuth(`${api.API_URL}/feira/tags/${feiraId}`, {
            method: 'GET'
          });
          
          const dataFeiraTags = await responseFeiraTags.json();
          setTags(dataFeiraTags.data);
          
          // Filtra as tags disponíveis
          const usedTagIds = dataFeiraTags.data.map(tag => tag.tag_id);
          const filtered = dataTags.data.filter(tag => !usedTagIds.includes(tag.id));
          setFilteredAvailableTags(filtered);
        } else {
          setFilteredAvailableTags(dataTags.data);
        }
      } catch (err) {
        console.error("Erro ao carregar dados:", err);
      }
    };
  
    carregarDados();
  }, [feiraId, editando]);

  // Limpa o formulário
  const limparFormulario = () => {
    setTagId('');
    setCobrarPorM2(false);
    setValor(0);
    setEditandoId(null);
  };

  const handleSalvar = async () => {
    const payload = {
      id: editandoId,
      feira_id: feiraId,
      tag_id: tagId,
      cobra_por_metro: cobra_por_metro,
      valor: parseFloat(valor) || 0
    };
  
    try {
      const method = editandoId ? 'PUT' : 'POST';
      const response = await fetchComAuthJson(`${api.API_URL}/tagsFeira`, {
          method: method,
          body: JSON.stringify(payload)
      });
      
      if (response.ok) {
        // Recarrega as tags da feira
        const updatedResponse = await fetchComAuth(`${api.API_URL}/feira/tags/${feiraId}`, {
          method: 'GET'
        });
     
        const updatedData = await updatedResponse.json();
        setTags(updatedData.data);
        
        // Atualiza a lista de tags disponíveis
        const usedTagIds = updatedData.data.map(tag => tag.tag_id);
        const filtered = availableTags.filter(tag => !usedTagIds.includes(tag.id));
        setFilteredAvailableTags(filtered);
        
        setModalAberto(false);
        limparFormulario();
      }
    } catch (err) {
      console.error('Erro ao salvar tag:', err);
    }
  };

  // Prepara o formulário para edição
  const handleEditar = (tag) => {
    setTagId(tag.tag_id);
    setCobrarPorM2(tag.cobra_por_metro);
    setValor(tag.valor);
    setEditandoId(tag.id);
    
    // Garante que a tag atual está disponível para seleção
    if (!availableTags.some(t => t.id === tag.tag_id)) {
      setAvailableTags(prev => [...prev, { id: tag.tag_id, nome: tag.tag?.nome || 'Tag atual' }]);
      setFilteredAvailableTags(prev => [...prev, { id: tag.tag_id, nome: tag.tag?.nome || 'Tag atual' }]);
    }
    
    setModalAberto(true);
  };

  // Remove uma tag
  const handleExcluir = async (id) => {
    try {
        await fetchComAuth(`${api.API_URL}/tagsFeira/${id}`, {
          method: 'DELETE'
        });
        
        const response = await fetchComAuth(`${api.API_URL}/feira/tags/${feiraId}`, {
          method: 'GET'
        });
        const updatedData = await response.json();
        setTags(updatedData.data);
        
        // Atualiza a lista de tags disponíveis
        const usedTagIds = updatedData.data.map(tag => tag.tag_id);
        const filtered = availableTags.filter(tag => !usedTagIds.includes(tag.id));
        setFilteredAvailableTags(filtered);
    } catch (err) {
        console.error('Erro ao excluir tag:', err);
    }
    };

  // Obtém o nome da tag pelo ID
  const getTagName = (id) => {
    const tag = availableTags.find(t => t.id === id) || 
              tags.find(t => t.tag_id === id)?.tag ||
              { nome: 'Tag selecionada' };
  
    return tag.nome;
  };

  return (
    <div>
      <Row>
        <Col lg={12}>
          <Card>
            <CardHeader>
              <Button color="success" onClick={() => { limparFormulario(); setModalAberto(true); }}>
                <i className="ri-add-line align-bottom me-1"></i> Nova Configuração
              </Button>
            </CardHeader>
            <CardBody>
              <div id="tagsLista">
                {tags.length === 0 ? (
                  <p className="text-muted">Nenhuma tag configurada ainda.</p>
                ) : (
                  <div className="table-responsive">
                    <Table className="table align-middle table-nowrap">
                      <thead className="table-light">
                        <tr>
                          <th>Tag</th>
                          <th>Cobra por m²</th>
                          <th>Valor</th>
                          <th>Ações</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tags.map((tag) => (
                          <tr key={tag.id}>
                            <td>{getTagName(tag.tag_id)}</td>
                            <td>{tag.cobra_por_metro ? 'Sim' : 'Não'}</td>
                            <td>R$ {tag.valor.toFixed(2)}</td>
                            <td>
                              <Button color="warning" size="sm" className="me-2" onClick={() => handleEditar(tag)}>
                                Editar
                              </Button>
                              <Button color="danger" size="sm" onClick={() => handleExcluir(tag.id)}>
                                Excluir
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Modal isOpen={modalAberto} toggle={() => setModalAberto(!modalAberto)} centered>
        <ModalHeader toggle={() => setModalAberto(!modalAberto)}>
            {editandoId ? 'Editar Configuração' : 'Nova Configuração'}
        </ModalHeader>
        <ModalBody>
            <Form>
            <FormGroup>
                <Label>Tag</Label>
                <Input
                    type="select"
                    value={tagId}
                    onChange={(e) => setTagId(e.target.value)}
                    >
                    <option value="">Selecione uma tag</option>
                    {/* Mostra a tag atual em edição */}
                    {editandoId && tagId && (
                        <option value={tagId}>
                        {getTagName(tagId)}
                        </option>
                    )}
                    
                    {/* Mostra tags disponíveis que não são a tag atual */}
                    {filteredAvailableTags
                        .filter(tag => !editandoId || tag.id !== tagId)
                        .map((tag) => (
                        <option key={tag.id} value={tag.id}>
                            {tag.nome}
                        </option>
                    ))}
                </Input>
            </FormGroup>
            
            <FormGroup>
                <Label>Valor</Label>
                <Input
                type="number"
                value={valor}
                onChange={(e) => setValor(e.target.value)}
                placeholder="0.00"
                min="0"
                step="0.01"
                />
            </FormGroup>

            <FormGroup check>
                <div className="mb-0">
                <li className="d-flex">
                    <div className="flex-shrink-0">
                    <div className="form-check form-switch form-switch-lg">
                        <Input 
                        className="form-check-input" 
                        type="checkbox" 
                        role="switch" 
                        id="cobra_por_metro"
                        checked={cobra_por_metro}
                        onChange={(e) => setCobrarPorM2(e.target.checked)}
                        />
                    </div>
                    </div>
                    <div className="flex-grow-1">
                    <label htmlFor="cobra_por_metro" className="form-check-label fs-14">Cobra por metro quadrado</label>
                    <p className="text-muted">Valor será multiplicado pela area do espaço</p>
                    </div>
                </li>
                </div>
            </FormGroup>
            </Form>
        </ModalBody>
        <ModalFooter>
            <Button color="secondary" onClick={() => setModalAberto(false)}>Cancelar</Button>
            <Button color="primary" onClick={handleSalvar}>
            {editandoId ? 'Atualizar' : 'Salvar'}
            </Button>
        </ModalFooter>
        </Modal>
    </div>
  );
};

export default TelaConfiguracoesTags;